<div class="md:flex md:items-center md:justify-between">
	<div class="min-w-0 flex-1">
		<h1 class="">Kalender</h1>
	</div>
  <div class="mt-4 flex md:ml-4 md:mt-0 gap-2">
    <button type="submit" class="primary" (click)="openAppointment()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10.75 6.75C10.75 6.33579 10.4142 6 10 6C9.58579 6 9.25 6.33579 9.25 6.75V9.25H6.75C6.33579 9.25 6 9.58579 6 10C6 10.4142 6.33579 10.75 6.75 10.75H9.25V13.25C9.25 13.6642 9.58579 14 10 14C10.4142 14 10.75 13.6642 10.75 13.25V10.75H13.25C13.6642 10.75 14 10.4142 14 10C14 9.58579 13.6642 9.25 13.25 9.25H10.75V6.75Z" fill="#0F172A"/>
      </svg>
      <span>Termin erstellen</span>
    </button>
  </div>
</div>
<div *ngIf="loading" class="py-4">
  <div role="status">
    <svg aria-hidden="true" class="inline w-9 h-9 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#333333"/>
    </svg>
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div *ngIf="!loading">
  <div class="my-8">
    <ol class="mt-2 divide-y divide-grey-light text-sand text-txt-large">
      <li *ngFor="let appointment of appointments" class="py-4 sm:flex">
        <p class="w-28 flex-none">{{ (appointment.acf.date | date:"dd.MM.YYYY") }}</p>
        <p class="w-48 flex-none">{{ appointment.acf.decease.acf.firstname }} {{ appointment.acf.decease.acf.lastname }}</p>
        <div class="mt-2 flex-auto text-grey sm:mt-0">
          <p><strong>{{ appointment.acf.title }}</strong></p>
          <p>{{ appointment.acf.description }}</p>
        </div>
        <p class="flex-none sm:ml-6">{{ appointment.acf.time }}</p>
      </li>
    </ol>
  </div>
</div>
<div *ngIf="appointment_slide_over" class="relative z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
        <div class="pointer-events-auto w-screen max-w-5xl">
          <div class="flex h-full flex-col overflow-y-scroll bg-white p-6 shadow-xl">
            <div>
              <div class="flex justify-end mb-2">
                <a (click)="appointment_slide_over = false" type="button" class="cursor-pointer">
                  <span class="sr-only">Schließen</span>
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 22.5L22.5 7.5M7.5 7.5L22.5 22.5" stroke="#505050" stroke-width="1.875" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </a>
              </div>
              <div class="flex items-start justify-between mb-4">
                <h2 id="slide-over-title">Termin</h2>
              </div>
            </div>
            <div>
              <form [formGroup]="form_appointment">
                <div class="mt-4">
                  <label>Titel (*)</label>
                  <div class="mt-2">
                    <input formControlName="title" type="text">
                  </div>
                </div>
                <div class="mt-4">
                  <label>Datum (*)</label>
                  <div class="mt-2">
                    <app-datepicker controlName="date" time="active"></app-datepicker>
                  </div>
                </div>
                <div class="mt-4">
                  <label>Sterbefall (*)</label>
                  <div class="mt-2">
                    <select formControlName="decease">
                      <option *ngFor="let decease of deceases" [value]="decease.id">{{ decease.acf.firstname }} {{ decease.acf.lastname }}</option>
                    </select>
                  </div>
                </div>
                <div class="mt-4">
                  <label>Beschreibung</label>
                  <div class="mt-2">
                    <textarea formControlName="description" rows="4"></textarea>
                  </div>
                </div>
                <div class="mt-6 flex items-center justify-end gap-x-6">
                  <button type="submit" (click)="saveAppointment(form_appointment.value, false)" [disabled]="form_appointment.invalid" class="primary">Speichern</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>